import {
    FETCH_REFERRAL_LIST_REQUEST,
    FETCH_REFERRAL_LIST_SUCCESS,
    FETCH_REFERRAL_LIST_FAILURE
} from "../actions/types";

const initialState = {
    loading: false,
    referralData: [],
    error: null,
};
export const ReferralListReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REFERRAL_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_REFERRAL_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                referralData: action?.payload?.data,
            };
        case FETCH_REFERRAL_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};